import { render, staticRenderFns } from "./AnalitycsPage.vue?vue&type=template&id=78568509&scoped=true&"
import script from "./AnalitycsPage.vue?vue&type=script&lang=js&"
export * from "./AnalitycsPage.vue?vue&type=script&lang=js&"
import style0 from "./AnalitycsPage.vue?vue&type=style&index=0&id=78568509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78568509",
  null
  
)

export default component.exports